import { render, staticRenderFns } from "./zinkom.vue?vue&type=template&id=35a7edb1"
import script from "./zinkom.vue?vue&type=script&lang=js"
export * from "./zinkom.vue?vue&type=script&lang=js"
import style0 from "./zinkom.vue?vue&type=style&index=0&id=35a7edb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports